import { EnvironmentType } from '@src/app/models/environment.type';

export const environment: EnvironmentType = {
  production: true,
  enableSSR: false,
  hostUrl: `https://client-gateway.smileloan.co.za/client-api`,
  initRecaptcha: false,
  isLocalhost: false,
  cookieDomain: '.smileloan.co.za',
};
